<template>
<v-container fill-height justify-center align-center >
  <!-- <v-layout row > -->
    <v-flex xs12 sm10 lg5 md8>
      <v-card class="mt-0 pt-0">
          <v-card-title class="primary">
            <h4 style="color:white">TAP-LOGIN</h4>
          </v-card-title>
          <v-card-text>
              <form @submit.prevent="login">
                <v-layout row wrap>
                  <v-flex  xs12 md12>
                    <v-text-field box name="email" v-model="email" label="Email" value="Input text"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex  xs12 md12>
                    <v-text-field box name="password" type="password" v-model="pass" label="Password" value="Input text"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-btn small flat color="primary" to="/forgotpassword" round>Forgot Password</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat to="/signup" color="primary" round outline>Signup</v-btn>
                  <v-btn type="submit" color="primary" round>login</v-btn>
                </v-layout>
              </form>
        </v-card-text>
      </v-card>
    </v-flex>
  <!-- </v-layout> -->
  </v-container>
</template>
<script>
import auth from '../utils/auth'
export default {
  data () {
    return {
      email: '',
      pass: ''
    }
  },
  methods: {
    login () {
      auth.login(this.email, this.pass, () => {
        this.$router.push(this.$route.query.redirect || '/welcome')
      })
    }
  }
}
</script>
<style lang="stylus">
  @import '../stylus/main'

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue